import { ThumbsUp, MessageCircle, Share2, MoreHorizontal } from "lucide-react";

const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1618424599646-14f0a25990f1?w=600&h=400&fit=crop";

export const FacebookPreview = ({ content, media }) => {
  const displayMedia = media && media.length > 0 ? media[0] : null;

  return (
    <div className="preview-container bg-white rounded-lg overflow-hidden" data-testid="facebook-preview">
      {/* Header */}
      <div className="flex items-center gap-3 p-3">
        <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200">
          <img 
            src="https://images.unsplash.com/photo-1631387019069-2ff599943f9a?w=80&h=80&fit=crop&crop=face"
            alt="Profile"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <p className="font-semibold text-[15px] text-[#050505]">Mon Compte</p>
          <div className="flex items-center gap-1 text-[13px] text-[#65676B]">
            <span>À l'instant</span>
            <span>·</span>
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 1.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13z"/>
            </svg>
          </div>
        </div>
        <button className="p-2 hover:bg-gray-100 rounded-full">
          <MoreHorizontal className="w-5 h-5 text-[#65676B]" />
        </button>
      </div>

      {/* Content */}
      <div className="px-4 pb-3">
        <p className="text-[15px] text-[#050505] leading-[1.34] whitespace-pre-wrap">
          {content || "Écrivez votre post..."}
        </p>
      </div>

      {/* Media */}
      {(displayMedia || !content) && (
        <div className="relative">
          {displayMedia?.type === "video" ? (
            <video 
              src={displayMedia.url} 
              className="w-full aspect-video object-cover bg-gray-100"
              controls
            />
          ) : (
            <img 
              src={displayMedia?.url || DEFAULT_IMAGE} 
              alt="Post media"
              className="w-full aspect-[1.91/1] object-cover bg-gray-100"
            />
          )}
        </div>
      )}

      {/* Engagement Stats */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
        <div className="flex items-center gap-1">
          <div className="flex -space-x-1">
            <div className="w-[18px] h-[18px] rounded-full bg-[#1877F2] flex items-center justify-center">
              <ThumbsUp className="w-2.5 h-2.5 text-white fill-white" />
            </div>
            <div className="w-[18px] h-[18px] rounded-full bg-red-500 flex items-center justify-center text-[10px]">
              ❤️
            </div>
          </div>
          <span className="text-[13px] text-[#65676B] ml-1">125</span>
        </div>
        <div className="flex gap-4 text-[13px] text-[#65676B]">
          <span>24 commentaires</span>
          <span>8 partages</span>
        </div>
      </div>

      {/* Actions */}
      <div className="flex border-t border-gray-200">
        <button className="flex-1 flex items-center justify-center gap-2 py-3 text-[#65676B] hover:bg-gray-100 transition-colors">
          <ThumbsUp className="w-5 h-5" />
          <span className="font-semibold text-[15px]">J'aime</span>
        </button>
        <button className="flex-1 flex items-center justify-center gap-2 py-3 text-[#65676B] hover:bg-gray-100 transition-colors">
          <MessageCircle className="w-5 h-5" />
          <span className="font-semibold text-[15px]">Commenter</span>
        </button>
        <button className="flex-1 flex items-center justify-center gap-2 py-3 text-[#65676B] hover:bg-gray-100 transition-colors">
          <Share2 className="w-5 h-5" />
          <span className="font-semibold text-[15px]">Partager</span>
        </button>
      </div>
    </div>
  );
};

export default FacebookPreview;
